
var id = "restart-disabled";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 240 240\" id=\"restart-disabled\">\n<style type=\"text/css\">\n\t#restart-disabled .st0{fill:#BDBDBD;}\n</style>\n<path class=\"st0\" d=\"M210,110c-5.52,0-10,4.48-10,10c0,44.18-35.82,80-80,80s-80-35.82-80-80s35.82-80,80-80\n\tc13.89,0,26.94,3.56,38.32,9.79l-8.96,8.96c-1.63,1.63-0.89,4.42,1.34,5.02l23.96,6.42l23.96,6.42c2.23,0.6,4.27-1.44,3.67-3.67\n\tl-6.42-23.96l-6.42-23.96c-0.6-2.23-3.38-2.98-5.02-1.34l-11.49,11.49C157.6,25.55,139.45,20,120,20C64.77,20,20,64.77,20,120\n\ts44.77,100,100,100s100-44.77,100-100C220,114.48,215.52,110,210,110z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
